import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import OurMilestone from "./sections/OurMilestone";
import SeniorLedExcellence from "./sections/SeniorLedExcellence";
import AiInAction from "./sections/AiInAction";
import FooterEssentials from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <OurMilestone />
      <SeniorLedExcellence />
      <AiInAction />
      <FooterEssentials />
    </div>;
}